import AmbassadorShell, { card, eyebrow, ghostBtn, h1Style, muted, primaryBtn, Reveal } from "./_AmbassadorShell";
import { Link } from "react-router-dom";

// Circle broadcasts and event scheduling have moved to the shared
// ElectricSheep operator console while the data backend is consolidated.
export default function AmbassadorCircle() {
  return (
    <AmbassadorShell>
      <Reveal>
        <p style={eyebrow}>Your Circle · cutover in progress</p>
        <h1 style={h1Style}>Circle tools are migrating.</h1>
        <div style={{ ...card, marginTop: 16 }}>
          <p style={{ color: muted, fontSize: 16, margin: 0 }}>
            Your Circle members, founder drop-in scheduling, and broadcasts are
            being moved to the shared ElectricSheep backend. Until that ships,
            email <strong>insiders@hireeva.co</strong> to request a founder
            drop-in or send a Circle broadcast on your behalf.
          </p>
          <div style={{ marginTop: 16, display: "flex", gap: 10, flexWrap: "wrap" }}>
            <Link to="/ambassadors/dashboard" style={primaryBtn}>Back to dashboard →</Link>
            <Link to="/ambassadors/playbook" style={ghostBtn}>Read the playbook</Link>
          </div>
        </div>
      </Reveal>
    </AmbassadorShell>
  );
}